import isEmpty from 'lodash/isEmpty';
import * as actionTypes from 'store/action-types';
import { InventoryGroupState, Action } from 'shared/interface';
import { PER_PAGE } from 'shared/constants/constants';

const initialState: InventoryGroupState = {
	inventoryGroupList: [],
	pagination: {
		current_page: 1,
		from: 1,
		last_page: 1,
		per_page: PER_PAGE,
		to: 1,
		total: 0
	},
	columns: {},
	sort: {
		orderBy: 'asc',
		orderByColumn: 'id'
	},
}

const reducer = (state: InventoryGroupState = initialState, action: Action): InventoryGroupState => {
	switch (action.type) {
		case actionTypes.FETCH_INVENTORY_GROUP_INIT:
			return {
				...state,
				inventoryGroupList: [],
				sort: {
					orderBy: action.payload.orderBy,
					orderByColumn: action.payload.orderByColumn,
				},
				pagination: {
					...state.pagination,
					current_page: isEmpty(action.payload.filters) ? state.pagination.current_page : action.payload.page,
					last_page: isEmpty(action.payload.filters) ? state.pagination.last_page : 1,
				}
			}
		case actionTypes.FETCH_INVENTORY_GROUP_SUCCESS:
			return {
				...state,
				inventoryGroupList: action.payload.items,
				pagination: action.payload.pagination,
				columns: action.payload.columns,
				sort: {
					orderBy: action.payload.query.queryData.orderBy,
					orderByColumn: action.payload.query.queryData.orderByColumn,
				}
			};
		case actionTypes.UPDATE_INVENTORY_GROUP:
			return {
				...state,
				inventoryGroupList: action.payload.data,
				pagination: { ...state.pagination, current_page: 1 },
				sort: {
					orderBy: action.payload.query.queryData.orderBy,
					orderByColumn: action.payload.query.queryData.orderByColumn,
				}
			};
		case actionTypes.CHANGE_INVENTORY_GROUP_STATUS_SUCCESS:
			return {
				...state,
				inventoryGroupList: action.payload.data,
			};
		default:
			return state;
	}
}

export default reducer;
